module.exports = __webpack_public_path__ + "static/media/linkedin-logo-charcoal.42009ab2.svg";